import { IconDefinition, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { faCheckCircle } from "@fortawesome/pro-regular-svg-icons/faCheckCircle";
import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons/faExclamationCircle";
import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons/faExclamationTriangle";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withStyles, WithStyles } from "@mui/styles";
import messageBoxStyle from "assets/jss/mui-extras/messageBoxStyle";
import classNames from "classnames";
import * as React from "react";
import { Fragment } from "react";

interface IProps {
    message: string | JSX.Element | Array<string | JSX.Element>;
    variant?: "info" | "success" | "warning" | "error" | "primary" | "notice";
    size?: "small" | "normal" | "medium" | "large";
    icon?: IconDefinition;
    hideIcon?: boolean;
    action?: React.ReactNode | React.ReactNode[];
};

type Props = IProps & WithStyles<typeof messageBoxStyle>;

const MuiMessageBox: React.FC<Props> = (props) => {
    const { action, classes, message, variant, size, hideIcon, icon, children } = props;

    let defIcon: IconDefinition = null;
    switch (variant) {
        case "success": defIcon = faCheckCircle; break;
        case "warning": defIcon = faExclamationTriangle; break;
        case "error": defIcon = faExclamationCircle; break;
        case "info": defIcon = faInfoCircle; break;
    }

    let iconSize: SizeProp;
    switch (size) {
        case "large": iconSize = "6x"; break;
        case "medium": iconSize = "3x"; break;
        default: iconSize = "1x";
    }

    const iconToPrint =
        hideIcon !== true && (icon || defIcon)
            ? <FontAwesomeIcon fixedWidth icon={icon || defIcon} size={iconSize} />
            : null;

    const m = Array.isArray(message)
        ? (message as Array<any>).reduce(
            (acc: any, v: any) => {
                const item = typeof (v) === "string"
                    ? (<Fragment><span>{v}</span><br /></Fragment>)
                    : v;
                acc.push(item);
                return acc;
            }, [])
        : message || children;

    return (
        <div className={classNames(classes.root, classes[variant], classes[size])}>

            <div className={classes.container}>
                {
                    iconToPrint &&
                    <div className={classes.iconContainer}>{iconToPrint}</div>
                }
                <div className={classes.messageContainer}>{m}</div>
            </div>

            {
                action &&
                <div className={classes.container}>
                    <div className={classes.action}>
                        {action}
                    </div>
                </div>
            }
        </div>
    );
};


MuiMessageBox.defaultProps = {
    size: "medium",
    variant: "info"
};

export default withStyles(messageBoxStyle)(MuiMessageBox);
